import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {
    addQaCategoryApi, deleteQaCategoryApi,
    getQaCategoryApi,
    updateQaCategoryApi
} from "../../../services/manage-product/setting/qaCategoryService";


export const getAllQaCategories = createAsyncThunk('qaCategory/getQaCategory', async (filters, {dispatch}) => {
    const response = await getQaCategoryApi(filters);
    return response.response;
});

export const addQaCategory = createAsyncThunk('qaCategory/addQaCategory', async (qaCategory, {
    dispatch,
    getState
}) => {
    try {
        const response = await addQaCategoryApi(qaCategory);
        const data = await response.response;
        dispatch(getAllQaCategories());
        toast.success("Add item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const updateQaCategory = createAsyncThunk('qaCategory/updateQaCategory', async (qaCategory, {
    dispatch,
    getState
}) => {
    try {
        const response = await updateQaCategoryApi(qaCategory, qaCategory.id);
        const data = await response.response;
        dispatch(getAllQaCategories());
        toast.success("Update item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const deleteQaCategory = createAsyncThunk('qaCategory/deleteQaCategory', async (id, {
    dispatch,
    getState
}) => {
    try {
        const response = await deleteQaCategoryApi(id);
        const data = await response.response;
        dispatch(getAllQaCategories());
        toast.success("Delete item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

const qaCategoryAdapter = createEntityAdapter({});

export const {selectAll: selectQaCategory, selectById: selectQaCategoryById} = qaCategoryAdapter.getSelectors(
    state => state.product.qaCategory
);

const qaCategorySlice = createSlice({
    name: 'qaCategory',
    initialState: qaCategoryAdapter.getInitialState({
        searchText: '',
        addDialog: {
            component: 'qaCategory',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
    }),
    reducers: {
        selectQaCategorySearchText: {
            reducer: (state, action) => {
                state.searchText = action.payload;
            },
            prepare: event => ({payload: event.target.value || ''})
        },
        openNewDialog: (state, action) => {
            state.addDialog = {
                component: 'qaCategory',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        openEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: true
                },
                data: action.payload
            };
        },
        closeEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: false
                },
                data: null
            };
        },
    },
    extraReducers: {
        [getAllQaCategories.fulfilled]: qaCategoryAdapter.setAll
    }
});

export const {
    selectQaCategorySearchText, openNewDialog,
    closeNewDialog,
    openEditDialog,
    closeEditDialog
} = qaCategorySlice.actions;

export default qaCategorySlice.reducer;
